import { Component, OnInit } from "@angular/core";
import {Organization, User} from "../models/User";
import { CustomerService } from "../services/customer.service";
import { UserService } from "../services/user.service";
import { Customer } from "../models/Customer";
import { NavigationEnd, Router } from "@angular/router";
import { ServerTimeService } from "../services/server-time.service";
import {interval} from "rxjs";
import { AuthError, AuthService } from "../services/auth.service";
import {
    faUser,
    faUsers,
    faLock,
    faPlus,
    faCogs,
} from "@fortawesome/pro-solid-svg-icons";
import {
    faPowerOff,
    faGlobeAmericas,
    faCheckSquare,
    faShieldAlt,
    faTags,
    faArchive,
    faUserCircle,
    faIdCardAlt,
    faSlidersH,
    faUserChart,
    faRoute,
    faBox,
    faBookOpen,
} from "@fortawesome/pro-regular-svg-icons";
import { AuthService as AuthServiceSSO } from "@auth0/auth0-angular";
import { environment } from '../../environments/environment';

@Component({
    selector: "acad-restricted",
    templateUrl: "./restricted.component.html",
    styleUrls: ["./restricted.component.less"],
})
export class RestrictedComponent {
    currentUser: User;
    currentCustomer: Customer;
    currentUrl: string;
    currentTime: string;
    userUsesClaims: boolean = false;
    isSSOFlow: boolean = localStorage.getItem('isSSOFlow') === 'true'
    userOrganizations: Organization[] = null;
    organizationsLoaded: boolean = false;
    isMultiOrg: boolean = localStorage.getItem('isMultiOrg') === 'true';

    faUser = faUser;
    faUsers = faUsers;
    faLock = faLock;
    faCogs = faCogs;
    faPlus = faPlus;
    faPowerOff = faPowerOff;
    faGlobeAmericas = faGlobeAmericas;
    faCheckSquare = faCheckSquare;
    faShieldAlt = faShieldAlt;
    faTags = faTags;
    faArchive = faArchive;
    faUserCircle = faUserCircle;
    faIdCardAlt = faIdCardAlt;
    faSlidersH = faSlidersH;
    faUserChart = faUserChart;
    faRoute = faRoute;
    faBox = faBox;
    faBookOpen = faBookOpen;

    constructor(
        private customerService: CustomerService,
        private userService: UserService,
        private router: Router,
        private serverTimeService: ServerTimeService,
        private authService: AuthService,
        private auth0: AuthServiceSSO
    ) {
        this.currentUser = userService.currentUser;
        this.currentCustomer = customerService.currentCustomer;
        this.userUsesClaims = this.authService.userUsesClaims();
        userService.refreshAllUsers();

        router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.currentUrl = event.url;
                try {
                    this.authService.refreshTimeout();
                } catch (e) {
                    if (e instanceof AuthError) {
                        this.router.navigate([
                            "/login",
                            { errorCode: e.errorCode },
                        ]);
                    }
                }
            }
        });


        interval(1000).subscribe(() => {
            const now = this.serverTimeService.now();

            this.currentTime = now
                .tz(this.userService.currentUserSettings.timezone)
                .format("LLL z (UTCZ)");
        });

        if (this.isSSOFlow) {
            this.fetchOrganizations();
        }
    }

    switchOrganization() {
        this.auth0.loginWithRedirect()
    }

    isRestrictedRoot(): boolean {
        const url = this.currentUrl || this.router.url || '';
        return url === '/r' || url === '/r/';
    }

    goToNewView () {
        window.open( `${environment.microFrontends.auditTrails.scmUrl}/global/admin`, '_blank' );
    }

    goToNewAuditTrail () {
        window.open( `${ environment.microFrontends.auditTrails.scmUrl }/global/admin/user-admin/audit-trails`, '_blank' );
    }

    // SSO Flow
    fetchOrganizations() {
        this.userService.fetchUserOrganizations().subscribe({
            next: (organizations) => {
                this.userOrganizations = organizations;
                this.organizationsLoaded = true;

                // Prevent the 'company change' button from glitching on every page reload
                if (organizations.length > 1) {
                    localStorage.setItem('isMultiOrg', 'true');
                } else {
                    localStorage.setItem('isMultiOrg', 'false');
                }
            },
            error: (error) => {
                console.error(error);
            },
        });
    }
}
